import BaseModel from '@core/model';

import RestrictedPanelApi from '@packages/restricted-panels/api';

export class RestrictedPanel extends BaseModel {
    static name = 'RestrictedPanel';
    static entity = 'restrictedPanels';
    static Api = RestrictedPanelApi;

    static fields() {
        return {
            ...super.fields(),
            id: this.attr(null),
            name: this.string(null).nullable(),
            default: this.boolean(false),
            adviser: this.attr(null),
            adviser_id: this.string(null).nullable(),
            offers: this.attr([])
        };
    }

    static is_valid() {
        return this.name && this.offers && this.offers.length > 0;
    }
}

export default RestrictedPanel;
